import { FC } from 'react';

import { Select } from 'antd';
import { Interval, Metric } from 'common/types/dasboard';
import { observer } from 'mobx-react-lite';

import { DatePicker } from '../../components/DatePicker';

import { Charts } from './Charts';
import { DashboardViewModel } from './dashboard-view-model';
import { Section } from './Section';

import styles from './dashboard.module.scss';

interface IDashboardContent {
  model: DashboardViewModel;
}

const DashboardContent: FC<IDashboardContent> = observer(({ model }) => (
  <div className={styles.container}>
    <div className={styles.header}>
      <span className={styles.label}>Date range</span>
      <DatePicker.RangePicker
        value={[model.startDate, model.endDate]}
        allowClear={false}
        disabledDate={(current) => current.getTime() > model.today.getTime()}
        disabled={model.isLoading}
        className={styles.datePicker}
        onChange={model.onRangeChange}
        onOpenChange={model.onPickerOpenChange}
      />
    </div>
    <div className={styles.content}>
      <div className={styles.column}>
        <Section
          titles={['Finance', 'Value']}
          items={model.finance}
          prefix="$"
          isLoading={model.isLoading}
        />
      </div>
      <div className={styles.column}>
        <Section
          titles={['Orders', 'Value']}
          items={model.orders}
          isLoading={model.isLoading}
        />
      </div>
    </div>
    <div className={styles.chart}>
      <div className={styles.chart__actions}>
        <Select
          className={styles.select}
          onChange={(interval) => (model.interval = interval)}
          value={model.interval}
          options={Interval.map((it) => ({
            label: it,
            value: it,
          }))}
        />
        <Select
          className={styles.select}
          onChange={(metric) => (model.metric = metric)}
          value={model.metric}
          options={Metric.map((it) => ({
            label: it,
            value: it,
          }))}
        />
      </div>
      <div className={styles.chart_chart}>
        <Charts items={model.dataPoints} metric={model.metric} />
      </div>
    </div>
    <div className={styles.content}>
      <div className={styles.column}>
        <Section
          titles={['Cancellation', 'Value']}
          items={model.cancellations}
          isLoading={model.isLoading}
        />
      </div>
      <div className={styles.column}>
        <Section
          titles={['Refund', 'Value']}
          items={model.refunds}
          isLoading={model.isLoading}
        />
      </div>
    </div>
  </div>
));

export const DashboardPage: FC = () => {
  const model = new DashboardViewModel();

  return <DashboardContent model={model} />;
};
